"use client";

import { Button } from "@/client/designSystem/button";

export default function NotFound() {
  return (
    <div
      className="relative min-h-full flex items-center justify-center p-4 font-body"
      style={{ backgroundColor: "var(--report-bg-cream)" }}
    >
      <div className="relative z-10 max-w-md w-full bg-white rounded-2xl border border-[var(--report-border-light)] shadow-sm overflow-hidden">
        {/* Gradient top bar */}
        <div className="h-1 bg-gradient-to-r from-spring-leaves-500 to-spring-leaves-500/50" />

        <div className="p-6 space-y-4">
          <div className="space-y-2">
            <h2 className="font-display text-2xl font-semibold text-center text-[var(--report-text-primary)]">
              Page Not Found
            </h2>
            <p className="text-[var(--report-text-secondary)] text-center font-body">
              This page doesn&apos;t exist or may have moved.
            </p>
          </div>
          <div className="flex justify-center">
            <Button
              variant="secondary"
              onClick={() => (window.location.href = "/")}
            >
              Go Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
